import {
    BaselineKeyboardArrowDown,
    BaselineKeyboardArrowUp,
    BXSortDown,
    BXSortUp,
    BXSDownArrow,
    BXSUpArrow,
    CiCalendar,
    ClarityWarningStandardLine,
    CloseFilled,
    DatabaseBold,
    Iconify_tabler_DatabaseShare,
    Iconify_uit_LayerGgroup,
    PIPDatabaseOff,
    RiSortAsc,
    RiSortDesc,
    SharpKeyboardArrowDown,
    SharpKeyboardArrowLeft,
    SharpKeyboardArrowRight,
    SharpKeyboardArrowUp,
    SharpKeyboardDoubleArrowDown,
    SharpKeyboardDoubleArrowLeft,
    SharpKeyboardDoubleArrowRight,
    SharpKeyboardDoubleArrowUp,
    TDObjectStorage,
    LuFileJson,
    AntFileZipOutlined,
} from "@/src/components/Icons";

export const Icon = (props) => {
    const { icon = "", style, height, width, ...rest } = props;
    const [dataset, iconname] = icon.split(":");

    const _style = { height, width, ...style };

    rest.style = _style;

    const ICONS = {
        bx: {
            "sort-down": <BXSortDown {...rest} />,
            "sort-up": <BXSortUp {...rest} />,
        },
        bxs: {
            "down-arrow": <BXSDownArrow {...rest} />,
            "up-arrow": <BXSUpArrow {...rest} />,
        },
        clarity: {
            "warning-standard-line": <ClarityWarningStandardLine {...rest} />,
        },
        ci: {
            calendar: <CiCalendar {...rest} />,
        },
        "pepicons-pencil": {
            "database-off": <PIPDatabaseOff {...rest} />,
        },
        ph: {
            "database-bold": <DatabaseBold {...rest} />,
        },
        ri: {
            "sort-asc": <RiSortAsc {...rest} />,
            "sort-desc": <RiSortDesc {...rest} />,
        },
        tabler: {
            "database-share": <Iconify_tabler_DatabaseShare {...rest} />,
        },
        uit: {
            "layer-group": <Iconify_uit_LayerGgroup {...rest} />,
        },
        carbon: {
            "close-filled": <CloseFilled {...rest} />,
        },
        ic: {
            "sharp-keyboard-arrow-left": <SharpKeyboardArrowLeft {...rest} />,
            "sharp-keyboard-arrow-right": <SharpKeyboardArrowRight {...rest} />,
            "sharp-keyboard-arrow-down": <SharpKeyboardArrowDown {...rest} />,
            "sharp-keyboard-arrow-up": <SharpKeyboardArrowUp {...rest} />,
            "sharp-keyboard-double-arrow-left": <SharpKeyboardDoubleArrowLeft {...rest} />,
            "sharp-keyboard-double-arrow-right": <SharpKeyboardDoubleArrowRight {...rest} />,
            "sharp-keyboard-double-arrow-down": <SharpKeyboardDoubleArrowDown {...rest} />,
            "sharp-keyboard-double-arrow-up": <SharpKeyboardDoubleArrowUp {...rest} />,
            "baseline-keyboard-arrow-up": <BaselineKeyboardArrowUp {...rest} />,
            "baseline-keyboard-arrow-down": <BaselineKeyboardArrowDown {...rest} />,
        },
        tdesign: {
            "object-storage": <TDObjectStorage {...rest} />,
        },
        lucide: {
            "file-json": <LuFileJson {...rest} />,
        },
        "ant-design": {
            "file-zip-outlined": <AntFileZipOutlined {...rest} />,
        },
    };

    return <>{ICONS?.[dataset]?.[iconname]}</>;
};
